import { render, staticRenderFns } from "./bargainDialog.vue?vue&type=template&id=3663ea15&scoped=true"
import script from "./bargainDialog.vue?vue&type=script&lang=js"
export * from "./bargainDialog.vue?vue&type=script&lang=js"
import style0 from "./bargainDialog.vue?vue&type=style&index=0&id=3663ea15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3663ea15",
  null
  
)

export default component.exports